import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FB14BE1B-5BAD-44CD-9E68-CABE4A79F527
 * name skip-next-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-next-outline.svg
 * tags
 */
export const SkipNextOutlineIcon = createSvgIcon(<><path d="M6,18L14.5,12L6,6M8,9.86L11.03,12L8,14.14M16,6H18V18H16" /></>, 'SkipNextOutlineIcon');
export default SkipNextOutlineIcon